/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Marketing13Inputs */

const en__field_enum_tuda_marketing13 = /** @type {(inputs: _Field_Enum_Tuda_Marketing13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media, Communication & Marketing`)
};

const de__field_enum_tuda_marketing13 = /** @type {(inputs: _Field_Enum_Tuda_Marketing13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medien, Kommunikation & Marketing`)
};

/**
* | output |
* | --- |
* | "Media, Communication & Marketing" |
*
* @param {_Field_Enum_Tuda_Marketing13Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_marketing13 = /** @type {((inputs?: _Field_Enum_Tuda_Marketing13Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Marketing13Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_marketing13(inputs)
	return de__field_enum_tuda_marketing13(inputs)
});
export { _field_enum_tuda_marketing13 as "_field_enum_TUDA_MARKETING" }